// extracted by mini-css-extract-plugin
export default {"figure":"ImageBlock_figure__yb2Af","image":"ImageBlock_image__Jp0bc","placeholder":"ImageBlock_placeholder__Ava-z","caption":"ImageBlock_caption__2fGjV"};